module.exports = __webpack_public_path__ + "img/quest_icon_0044_impact.8648240c.png";